import { PermalinksState } from './permalinks.types';

export const PERMALINKS_INITIAL_STATE: PermalinksState = {
  list: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
};

export const PERMALINK_FETCHING_ERROR_PREFIX = 'Failed to fetch permalinks';
export const PERMALINK_CREATING_ERROR_PREFIX = 'Failed to create permalink';
export const PERMALINK_UPDATING_ERROR_PREFIX = 'Failed to update permalink';
